









































import {Component, Vue} from "vue-property-decorator";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";
import LoadingOverlay from "@/resources/components/LoadingOverlay.vue";

@Component({
    components: {LoadingOverlay, LoadSpinner}
})
export default class Login extends Vue {
    private username: string = '';
    private password: string = '';

    private async login(): Promise<void> {
        this.resetFlash();
        await this.task<void>(async () => {
            await this.$store.dispatch('auth/login', {
                email: this.username,
                password: this.password,
            });
        });

        await this.$router.replace({name: 'dashboard'});
    }
}
